import { cn } from "~/lib/cn";

/** Up to two initials from a display name ("Sofía Marín" → "SM"). */
function initialsFrom(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "?";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
}

interface AvatarProps {
  name: string;
  /** sm = 28px (header pill), md = 34px (mobile trigger), lg = 40px (identity block). */
  size?: "sm" | "md" | "lg";
  ring?: boolean;
}

/** Initials avatar — `.avatar` atom from the design handoff (darkCard fill, ink-on-dark). */
export function Avatar({ name, size = "md", ring = false }: AvatarProps) {
  return (
    <span
      className={cn("avatar", size === "sm" && "sm", size === "lg" && "lg", ring && "ring")}
      aria-hidden="true"
    >
      {initialsFrom(name)}
    </span>
  );
}
